/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { SignalRClientDto } from '../models/signal-r-client-dto';


/**
 * Fonctions de gestion des clients SignalR
 */
@Injectable({
  providedIn: 'root',
})
export class ClientsSignalRService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation signalRClientsGetList
   */
  static readonly SignalRClientsGetListPath = '/api/signalr-clients/list';

  /**
   * Renvoie la liste des clients SignalR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signalRClientsGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  signalRClientsGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<SignalRClientDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsSignalRService.SignalRClientsGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SignalRClientDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des clients SignalR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `signalRClientsGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  signalRClientsGetList(params?: {
  }): Observable<Array<SignalRClientDto>> {

    return this.signalRClientsGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SignalRClientDto>>) => r.body as Array<SignalRClientDto>)
    );
  }

  /**
   * Path part for operation signalRClientsLoadList
   */
  static readonly SignalRClientsLoadListPath = '/api/signalr-clients/load-list';

  /**
   * Renvoie la liste des clients SignalR (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signalRClientsLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signalRClientsLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsSignalRService.SignalRClientsLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des clients SignalR (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `signalRClientsLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signalRClientsLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.signalRClientsLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation signalRClientsGet
   */
  static readonly SignalRClientsGetPath = '/api/signalr-clients/{id}';

  /**
   * Renvoie le client SignalR spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signalRClientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  signalRClientsGet$Response(params: {

    /**
     * Identifiant du client SignalR
     */
    id: string;
  }): Observable<StrictHttpResponse<SignalRClientDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsSignalRService.SignalRClientsGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SignalRClientDto>;
      })
    );
  }

  /**
   * Renvoie le client SignalR spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `signalRClientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  signalRClientsGet(params: {

    /**
     * Identifiant du client SignalR
     */
    id: string;
  }): Observable<SignalRClientDto> {

    return this.signalRClientsGet$Response(params).pipe(
      map((r: StrictHttpResponse<SignalRClientDto>) => r.body as SignalRClientDto)
    );
  }

}
